import React from "react"
import CabBox from "../CabCardBox"
import { useSelector } from "react-redux"

const MainCab = ({
  tripDetails,
}) => {
  const { cabs, distance } = useSelector((state) => state.cab)

  return (
    <div className="mainCab">
      <div className="cabCardBox__para">
        Showing {cabs?.length || 0} cabs from {tripDetails?.pickup_city}{" "}
        {tripDetails?.trip_type !== 2 && `to ${tripDetails?.drop_city}`} (
        Distance for selected route is {Math.ceil(distance)} kms )
      </div>

      <div className="mainCab__container">
        <div className="mainCab__container--right">
          <CabBox
            tripDetails={tripDetails}
          ></CabBox>
        </div>
      </div>
    </div>
  )
}

export default MainCab
